/**
 * @generated SignedSource<<6adbd8e5a5634af776e999c7864129ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserApiKeysSectionQuery$variables = {};
export type UserApiKeysSectionQuery$data = {
  readonly userApiKeys: ReadonlyArray<{
    readonly createdAt: string | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly lastUsed: string | null;
    readonly name: string;
    readonly owner: {
      readonly email: string;
      readonly id: string;
    };
  }>;
};
export type UserApiKeysSectionQuery = {
  response: UserApiKeysSectionQuery$data;
  variables: UserApiKeysSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DeveloperAPIKey",
    "kind": "LinkedField",
    "name": "userApiKeys",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserApiKeysSectionQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserApiKeysSectionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d6fa388872cc71e512a2262f2df4458",
    "id": null,
    "metadata": {},
    "name": "UserApiKeysSectionQuery",
    "operationKind": "query",
    "text": "query UserApiKeysSectionQuery {\n  userApiKeys {\n    id\n    name\n    createdAt\n    lastUsed\n    isActive\n    owner {\n      id\n      email\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7de105babce54a15932136471c702b2a";

export default node;
